<template lang="pug">
.swiper
    .container.mx-auto(:class="[spacingTop, spacingBottom]" v-if="contents && contents.length" ref="container")

        .title(v-if="heading && heading.title")
            h3 {{ heading.title }}

        splide(ref="splide" :options="options" @splide:move="forceLazyLoad" @splide:visible="forceLazyLoad")
            splide-slide.figure(v-for="slide in slides" :key="slide.id")
                SwiperImage(:slide="slide" )
</template>

<script>
// import { trim, get, debounce, cloneDeep } from '@/helpers';
import { trim, get, cloneDeep } from '@/helpers';

import { Splide, SplideSlide } from '@splidejs/vue-splide';
// import justifiedLayout from 'justified-layout';

import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import SwiperImage from './SwiperImage';

export default {
    name: 'Swiper',
    data() {
        return {
            options: {
                // type: 'loop',
                // autoWidth: true,
                rewind: false,
                pagination: false,
                perPage: 3,
                perMove: 1,
                gap: '2rem',
                breakpoints: {
                    640: {
                        perPage: 1
                    },

                    768: {
                        perPage: 2
                    }
                }
            }
        };
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        SwiperImage,
        Splide,
        SplideSlide
    },

    computed: {
        contents() {
            let contents = this.section.contents || [];
            return cloneDeep(contents).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        },

        heading() {
            return this.contents.find(content => content.key === 'heading');
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        slides() {
            let slides = [];

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            this.contents.forEach(content => {
                const image = get(content, 'images.0');
                if (!image) return false;

                let slide = {};

                slide.id = content.id;
                slide.title = content.title;
                slide.text = content.text;
                slide.hyperlink = content.hyperlink;

                const calculateFit = (data, maxHeight = 1800) => {
                    const pivot = data.pivot;
                    let fit = get(pivot, 'fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111';

                    // let { w, h, x, y, z } = pivot
                    let { w, h, z } = pivot;
                    if (!z) z = 1;

                    let width = data.width / z;
                    let height = data.height / z;
                    let aspectRatio = width / height;

                    maxHeight = Math.min(maxHeight, height);

                    if (w && h) {
                        aspectRatio = w / h;

                        if (h > maxHeight) {
                            height = maxHeight;
                        }

                        if (height * aspectRatio > data.width / z) {
                            height = width / aspectRatio;
                        } else {
                            width = height * aspectRatio;
                        }

                        fit = fit
                            .replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`)
                            .replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`);
                    } else if (!w && !h) {
                        if (height > maxHeight) {
                            height = maxHeight;
                            width = height * aspectRatio;
                        }

                        fit += `&w=${width}`;
                    }

                    return {
                        src: `${storageRoute}/images/${data.id}/${data.name}?${fit}`,
                        error: `${storageRoute}/images/${data.id}/${data.name}?${fit}&preview=greyscale`,
                        loading: `${storageRoute}/images/${data.id}/${data.name}?${fit}&preview=blur`,
                        width,
                        height,
                        aspectRatio
                    };
                };

                slide.thumbnail = calculateFit(image, 400);
                slide.image = calculateFit(image);

                slides.push(slide);
            });

            return slides;
        }
    },

    methods: {
        forceLazyLoad() {
            // console.log('force lazy load');
            this.$Lazyload.lazyLoadHandler();
        }
    },

    // mounted() {
    //     this.$refs.splide.go(1);
    //     setTimeout(() => {
    //         this.$refs.splide.go(-1);
    //         // this.forceLazyLoad();
    //     }, 1000);
    // }

    mounted() {
        window.addEventListener('scroll', this.forceLazyLoad);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.forceLazyLoad);
    }
};
</script>

<style lang="sass" scoped>

@import "~@/assets/sass/variables"

.swiper
    @apply text-center
    //background-color: $weinankauf-honey
    .container
        @apply py-12
        .title
            @apply font-semibold mb-8
            //color: $weinankauf-green
            font-size: 28px


.splide
    padding: 0 4rem
::v-deep
    .splide__arrow--prev
        left: 0
    .splide__arrow--next
        right:    0
</style>
